// Where a widget someone adds goes on a content calendar: last on the shelf down the right, as wide as the
// shelf. The gallery's Add, Connect's and every other add come through here (src/state/actions.ts addWidget).
// Light on purpose: the main app loads it, never the calendar's views.

import type { Board, WidgetItem } from "../../../shared/types";
import { get } from "../../state/store";
import type { Placement } from "../kinds";

export const SHELF_W = 300;

export function placeOnShelf(item: WidgetItem, board: Board): Placement {
  const mine = Object.values(get().items).filter((i) => i.boardId === board.id);
  const y = mine.length ? Math.max(...mine.map((i) => i.y + i.h)) + 24 : 0;
  return { ops: [{ op: "item.put", item: { ...item, x: 0, y, w: SHELF_W } }] };
}
